import { CategoryIcon } from './skillIcons';

// One category card of skill chips.
export function SkillCard({ group }) {
  return (
    <div className="skill-card glass">
      <div className="skill-card__head">
        <span className="skill-card__cat-icon">
          <CategoryIcon name={group.category} />
        </span>
        <h3 className="skill-card__title">{group.category}</h3>
      </div>
      <div className="skill-chips">
        {group.items.map(({ name, color }) => (
          <span className="skill-chip" key={name}>
            <span
              className="skill-chip__dot"
              style={{ background: color, boxShadow: `0 0 8px ${color}99` }}
            />
            {name}
          </span>
        ))}
      </div>
    </div>
  );
}
